import React, { Component} from "react";
import { Image, TouchableOpacity, View } from "react-native";
import TextView from "./TextView";
import { icons } from "../theme/icons";
import { componentStyles, appStyles } from "../theme/styles";
import Waiting from "./Waiting";
import { removeExpertFavRequest, addExpertFavRequest } from '../utils/api'
import { wp } from "../utils/responsive";
export default class FavoritServantItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            like: props.islike,
            waiting: false,
        }
    }

    render() {
        var item = this.props.data;
        return (
            <View style={componentStyles.favoirtExpertItem}>
                <View style={[appStyles.row, { marginRight: 10 }]}>

                    <View>
                        <TextView style={{ color: '#424242' }}>{item.name}</TextView>
                        <TextView style={{ color: 'gray', margin: 5, textAlign: 'right' }}>({item.job})</TextView>
                    </View>
                    <View style={componentStyles.fservantImage}>
                        <Image
                            source={{ uri: item.pic }}
                            style={componentStyles.iservantImage} />
                    </View>
                </View>

                <TouchableOpacity style={[componentStyles.addfavWraper, { alignSelf: 'center', width: wp(80) }]} onPress={() => {
                    this.setState({
                        waiting: true
                    })
                    if (this.state.like) {
                        removeExpertFavRequest(item.id, (isConnect, response) => {
                            this.setState({
                                waiting: false,
                            })
                            if (isConnect) {
                                this.props.onRefresh()

                            }
                        })
                    } else {
                        addExpertFavRequest(item.id, (isConnect, response) => {
                            this.setState({
                                waiting: false,
                            })
                            if (isConnect) {
                                this.props.onRefresh()
                                this.setState({
                                    like: true
                                })
                            }
                        })
                    }
                }}>
                    <Image source={this.state.like ? icons['like_fill'] : icons['like']} style={appStyles.smallIcon} />
                    <TextView style={{ fontSize: 10, color: 'gray', marginLeft: 15, width: wp(25), textAlign: 'right' }}>{this.state.like ? 'حذف از لیست' : 'افزودن به لیست'}</TextView>
                </TouchableOpacity>
                <Waiting waiting={this.state.waiting} />
            </View>
        );
    }
}


